import RestClient from './../../service/rest-client';
import {Signal} from 'signals';
import moment from 'moment'
import utils from './../../component/utils/utils';

class Service {

    event = {
        onFetchReceivedPackageStatsPerDay: new Signal(),
        onFetchReceivedPackagesByCountry: new Signal(),
        onFetchReceivedPackagesBySource: new Signal(),
        onFetchSeriesPackagesByDay: new Signal(),
        onFetchPackageInventory: new Signal(),
        onFetchSeriesPackagesByMonth: new Signal(),
    };

    fetchReceivedPackageStatsPerDay(intervalDates, typeOfRequest) {
        intervalDates = intervalDates || 1;
        typeOfRequest = typeOfRequest || 'table';

       RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

          var urlRequestTemplate = "/reporting/packagestats/perday?" + queryParams.join("&");

           return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
               var page = data.page_number;
               var pageSize = data.page_size,
                   offset = (page - 1) * pageSize;
               var pagingMetadata = {
                   page: data.page_number,
                   startIndex: offset + 1,
                   endIndex: offset + pageSize,
                   totalCount: data.total_count,
                   pageCount: Math.max(Math.ceil(data.total_count / pageSize), 1)//Always 1 page, even if 0 results
               };
                data.pagingMetadata = pagingMetadata;

               if (typeOfRequest === 'table') {
                   data.results = this.parseRequestDataPackageStatsPerDay(data.results);
                   this.event.onFetchReceivedPackageStatsPerDay.dispatch(data);
               } else if (typeOfRequest === 'chart') {
                   data.chartData = this.parseRequestDataForChartSignUpStatistics(data.results);
                   this.event.onFetchSignUpStatsPerDayChartData.dispatch(data);
               }
           }).catch((error) => {
               console.log("Error: " + error);
           });
    }

    parseRequestDataPackageStatsPerDay(resultData) {
        var parsedArray = resultData.map(function(dataItem) {
            var parsedObject = {};
            parsedObject.dateReceived = moment(dataItem.dateReceived).format("L")
            parsedObject.numberPackages = dataItem.countItems;

            return parsedObject;
        });
        return parsedArray;
    }

    // Received packages by Country
    fetchReceivedPackageStatsByCountry(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/packagestats/bycountry?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            var chartData = this.parseRequestDataReceivedPackagesByCountry(data.results);
            this.event.onFetchReceivedPackagesByCountry.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataReceivedPackagesByCountry(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.countryName);
            chartData.seriesDataList.push(dataItem.countItems);
        });

        return chartData;
    }

    // Received packages by Source
    fetchReceivedPackageStatsBySource(intervalDays) {
        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDays }`];

        var urlRequestTemplate = "/reporting/packagestats/bysource?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            var chartData = this.parseRequestDataReceivedPackagesBySource(data.results);
            this.event.onFetchReceivedPackagesBySource.dispatch(chartData);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataReceivedPackagesBySource(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList: []
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(dataItem.utmSource.replace(/first:|last:/gi, ''));
            chartData.seriesDataList.push(dataItem.countItems);
        });
        return chartData;
    }

    fetchPackageSeriesByDay(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/packagestats/byseries?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataSeriesForPackagesByDayStatistics(data.results);
            console.log("Series getRequest");
            console.log(data);
            this.event.onFetchSeriesPackagesByDay.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSeriesForPackagesByDayStatistics(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
            seriesDataList2: [],
            seriesDataList3: [],
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.dateReceived).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.totalPackageCount);
            chartData.seriesDataList2.push(dataItem.newPackageCount);
            chartData.seriesDataList3.push(dataItem.repeatPackageCount);
        });

        return chartData;
    }

    // package inventory
    fetchPackageInventory(intervalDates) {
        intervalDates = intervalDates || 1;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/packagestats/package-inventory?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            console.log("*** SERVICE DATA");
            console.log(data);

            data.chartData = this.parseRequestDataPackageInventory(data.results);
            this.event.onFetchPackageInventory.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataPackageInventory(resultData) {
        var chartData = {
            categoryList : [],
            seriesDataList1: [],
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryList.push(moment(dataItem.packageInventortyCreatedDate).format(utils.shortDateFormat));
            chartData.seriesDataList1.push(dataItem.totalInventory);
        });

        return chartData;
    }

    fetchPackageSeriesByMonth(intervalDates) {
        intervalDates = intervalDates || 366;

        RestClient.isSessionActive();
        var queryParams = [`interval_days=${ intervalDates }`];

        var urlRequestTemplate = "/reporting/packagestats/byseries?" + queryParams.join("&");

        return RestClient.getRequest(urlRequestTemplate,"").then((data) => {
            data.chartData = this.parseRequestDataSeriesForPackagesByMonthStatistics(data.results);
            console.log("Series getRequest for packages by month");
            console.log(data);
            this.event.onFetchSeriesPackagesByMonth.dispatch(data);
        }).catch((error) => {
            console.log("Error: " + error);
        });
    }

    parseRequestDataSeriesForPackagesByMonthStatistics(resultData) {
        var chartData = {
            categoryListByMonth : [],
            seriesDataListByMonth1: [],
            seriesDataListByMonth2: [],
            seriesDataListByMonth3: [],
        };

        resultData.forEach(function(dataItem) {
            chartData.categoryListByMonth.push(moment(dataItem.dateReceived).format("MM/YYYY"));
            chartData.seriesDataListByMonth1.push(dataItem.totalPackageCount);
            chartData.seriesDataListByMonth2.push(dataItem.newPackageCount);
            chartData.seriesDataListByMonth3.push(dataItem.repeatPackageCount);
        });

        return chartData;
    }

}

export default new Service();